import * as React from 'react';
import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';

type FilterSelectProps = {
    id?: string;
    label: string;
    name?: string;
    value?: number;
    onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
    options: { id: number; name: string }[];
    optionAllLabel: string;
};

export function FilterSelect({
    id,
    name,
    value,
    onChange,
    label,
    options,
    optionAllLabel
}: FilterSelectProps) {
    return (
        <TextField
            select
            aria-label={`Filter select for ${name}`}
            label={[label]}
            id={id}
            name={name}
            value={value ? value : 0}
            onChange={onChange}
            sx={{ marginRight: '8px', width: '250px' }}
        >
            <MenuItem value={0}>{optionAllLabel}</MenuItem>
            {options.map(({ id, name }) => (
                <MenuItem key={id} value={id}>
                    {name}
                </MenuItem>
            ))}
        </TextField>
    );
}
